import { buildSelector } from '@/shared/lib/store';

export const [useViewerData] = buildSelector((state) => state.viewer?.data);
